export enum AgentEnum {
  Registration = "registration_agent",
  Invoice = "invoice_agent",
  Delivery = "delivery_agent",
  Pickup = "pickup_agent",
  Menu = "menu_agent",
  SearchProducts = "search_products_agent",
  AddToCart = "add_to_cart_agent",
  RemoveFromCart = "remove_from_cart_agent",
  GetCart = "get_cart_agent",
  RegisterTypePayment = "register_type_payment_agent",
  SendOrder = "send_order_agent",
  CreateTicketSupport = "create_ticket_support_agent",
}
